import Autocomplete from "stimulus-autocomplete";

const hiddenSelector = "[data-autocomplete-target='hidden']"
const inputSelector = "[data-autocomplete-target='input']"
const iconSelector = "[data-autocomplete-target='icon']"

export default class extends Autocomplete {

  static targets = [
    "autocomplete",
    "icon"
  ]

  // if we need create a url 
  buildURL(query) {
    let url = new URL(this.urlValue, window.location.href)
    const params = new URLSearchParams(url.search.slice(1))
    params.append(this.queryParamValue, query)

    // This feature for just the submission_test_controller to check the all test schedules view
    const allTestScheduleItem = document.getElementById("all_test_schedule")
    if (allTestScheduleItem && allTestScheduleItem.checked) params.delete("lab_id")

    // Check and add for params for the single animal submission origin type
    const nonAnimalElem = document.getElementById("accession_animals_attributes_0_non_animal")
    if (nonAnimalElem) params.append("non_animal", nonAnimalElem.value)

    const ts_ids = document.getElementById('test_schedule_ids')
    if (ts_ids) params.append("exclude_ts_ids", ts_ids.value)

    url.search = params.toString()
    return url.toString()
  }
  
  connect(){
    super.connect()
    // Adding events to catch autocomplete change
    this.addAutocompleteChangeEvent()
    this.addInputEvent()
    this.toggleIconInitial(this.inputTargets)
    this.setInitialDisabledAllInputs()
  }

  disconnect(){
    super.disconnect()

    this.autocompleteTargets.forEach((item) => {
      item.removeEventListener('input', (event) => {
        this.toggleIcon(event)
      })
      item.removeEventListener('focusout', (event) => {
        this.checkedValidValue(event)
      })
    })

    this.autocompleteTargets.forEach((item) => {
      item.removeEventListener('autocomplete.change', (event) => {
        this.toggleIcon(event)
        this.dispatch("triggerAutocompleteChangeEvent", { detail: { event: event } } )
      })
    })

  }
  
  // For test ordering page , should be each test passive at initial
  setInitialDisabledAllInputs(){
    this.inputTargets.forEach((item) => {
      if (item.dataset.inputName === "test_test_schedule_id"){
        if (item.value){
          item.disabled = true
        }
      }
    })
  }

  addInputEvent(){
    this.autocompleteTargets.forEach((item) => {
      item.addEventListener('input', (event) => {
        this.toggleIcon(event)
      })
      item.addEventListener('focusout', (event) => {
        this.checkedValidValue(event)
        // TO-DO we can use when we need focusout
        // this.dispatch("focusoutAutocomplete", { detail: { event: event } } )
      })
    })
  }

  addAutocompleteChangeEvent(){
    this.autocompleteTargets.forEach((item) => {
      item.addEventListener('autocomplete.change', (event) => {
        this.toggleIcon(event)
        this.dispatch("triggerAutocompleteChangeEvent", { detail: { event: event } } )
      })
    })
  }

  toggleIconInitial(inputTargets){
    this.iconTargets.forEach((icon) => {
      let selectedInput = this.findTargetByQuerySelectorByItem(inputSelector, icon)
      if (selectedInput && selectedInput.value){
        icon.classList.remove('fa-search')
        icon.classList.add('fa-times')
      }
    })
  }

  toggleIcon(e){
    if (!e){
      return
    }
    
    let selectedIcon = this.findTargetByQuerySelectorByEvent(iconSelector, e)
    if (!selectedIcon) return
    
    if (e.type == 'autocomplete.change' ){
      selectedIcon.classList.remove('fa-search')
      selectedIcon.classList.add('fa-times')
    }

    if (e.type == 'input'){
      selectedIcon.classList.remove('fa-times', "fa-chevron-right","fa-rotate-90")
      selectedIcon.classList.add('fa-search')
    }
  }
  
  clear(e){

    let selectedInput = this.findTargetByQuerySelectorByEvent(inputSelector, e)

    if (e.target.classList.contains('fa-times') ){
      let selectedHidden = this.findTargetByQuerySelectorByEvent(hiddenSelector, e)
      if (e.target.dataset.inputName == "specimen_type"){
        this.addClearDispatchEvent(e)
      } else {
        this.dispatch("removeItemFromAutoCompleteData", {detail: {data: selectedHidden}})
      }
      selectedHidden.value = ""
      selectedInput.value = ""
      selectedHidden.dispatchEvent(new Event('change'))
      this.changeIconForDropboxEffect(e)
    } else if (e.target.classList.contains('fa-search')){
      this.fetchResults("")
    } else {
      if (selectedInput.value == ""){
          // if we want to load whole data after cleaning the autocomplete
          if (e.target.dataset.loadAll == 'true'){        
            this.fetchResults("")
            // TODO - we can put a dispatch and we can catch in any controller 
          }
        }
      }
  }

  addClearDispatchEvent(e){
    this.dispatch("clearExtraDataAfterClickClearIcon", {detail: {event: e}})
  }

  changeIconForDropboxEffect(e){
    let selectedIcon = this.findTargetByQuerySelectorByEvent(iconSelector, e)
    if (selectedIcon){
      selectedIcon.classList.remove('fa-search','fa-times' )
      selectedIcon.classList.add("fa-chevron-right","fa-rotate-90")
    }
  }

  findTargetByQuerySelectorByEvent(selector, e){
    const dataId = e.target.dataset.id
    const inputName = e.target.dataset.inputName
    return document.querySelector(`${selector}[data-id="${dataId}"][data-input-name="${inputName}"]`)
  }

  findTargetByQuerySelectorByItem(selector, item){    
    const dataId = item.dataset.id
    const inputName = item.dataset.inputName
    return document.querySelector(`${selector}[data-id="${dataId}"][data-input-name="${inputName}"]`)
  }

  checkedValidValue(e){
    let selectedHidden = this.findTargetByQuerySelectorByEvent(hiddenSelector, e)
    let selectedInput = this.findTargetByQuerySelectorByEvent(inputSelector, e)
    if (selectedHidden && ( selectedHidden.value == undefined || selectedHidden.value == "")){
      selectedHidden.required ? selectedInput.classList.add("required-field") : ""
      selectedInput.value = ""
      selectedHidden.value = ""
    } else {
      if (selectedInput) selectedInput.classList.remove("required-field")
    }
  }

}
